import React from "react";
import { appVersion } from "~/Commons";

/**
 * 受付スタンバイ画面専用フッター
 * バージョン番号のみを表示する
 */
const ReceptionStandbyFooter: React.FC = () => {
  return (
    <footer className="reception-standby-screen__footer">
      <p>v{appVersion}</p>
    </footer>
  );
};

export default ReceptionStandbyFooter;
